<template>
  <div>
    <b-card>
      <b-form inline style="flex-flow: unset">
        <label class="mr-sm-2" for="cities">Город</label>
        <multiselect
          select-label="Нажмите enter"
          selected-label="Выбрано"
          deselect-label="Нажмите enter"
          id="cities"
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="selected"
          track-by="ID"
          label="CITY"
          placeholder="Выберите город"
          :options="cities"
          :searchable="true"
          :allow-empty="false"
        >
          <span slot="noResult">Совпадений не найдено. Измените поисковый запрос.</span>
        </multiselect>
        <b-btn
          variant="success"
          @click="
            city = { isNewRecord: true };
            selected = {};
            model = JSON.parse(JSON.stringify(initModel));
          "
          >Добавить</b-btn
        >
      </b-form>
    </b-card>
    <b-row>
      <b-col>
        <b-card v-if="selected || (city && city.isNewRecord)">
          <template v-slot:header>
            <h6 class="mb-0" style="display: inline" v-if="city && city.isNewRecord">Новый город</h6>
            <h6 style="display: inline" v-else>Редактирование "{{ selected.CITY }}"</h6>
            <b-btn @click="remove(selected)" class="pull-right" size="sm" v-if="city && city.user_id" variant="danger"
              >Удалить</b-btn
            >
          </template>

          <vue-form-generator ref="form" :schema="schema" :model="model" :options="formOptions"> </vue-form-generator>
          <b-button href="#" variant="success" @click="save(model)"
            ><span v-if="model.ID">Сохранить</span><span v-else>Создать</span></b-button
          >
          <b-btn
            class="pull-right"
            @click="
              model.id = null;
              $emit('save', model);
            "
            v-if="model.id"
            variant="success"
            >Создать копию</b-btn
          >
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";

const FIELD_IS_REQUIRED = "Необходимо заполнить поле";
const isEmpty = (value) => value === null || value === undefined || isNaN(value);

export default {
  name: "Cities",
  props: {
    installations: Array,
  },
  data() {
    return {
      cities: [],
      city: {},
      selected: null,
      validator: {},
      initModel: {
        CITY: "Город n",
        FWindN: 0,
        FWindNE: 0,
        FWindE: 0,
        FWindSE: 0,
        FWindW: 0,
        FWindSW: 0,
        FWindS: 0,
        FWindNW: 0,
        CWind: 0,
        PWindN: 0,
        PWindNE: 0,
        PWindE: 0,
        PWindSE: 0,
        PWindS: 0,
        PWindSW: 0,
        PWindW: 0,
        PWindNW: 0,
        Temperature: 0,

        validator: {},
      },
      model: {
        CITY: "Город n",
        FWindN: 0,
        FWindNE: 0,
        FWindE: 0,
        FWindSE: 0,
        FWindW: 0,
        FWindSW: 0,
        FWindS: 0,
        FWindNW: 0,
        CWind: 0,
        PWindN: 0,
        PWindNE: 0,
        PWindE: 0,
        PWindSE: 0,
        PWindS: 0,
        PWindSW: 0,
        PWindW: 0,
        PWindNW: 0,
        Temperature: 0,

        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "Название",
                model: "CITY",
                id: "CITY",
                required: true,
                validator(value, field, model) {
                  if (value === null || value === undefined || !value.length) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Север)",
                model: "FWindN",
                id: "FWindN",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Северо-Восток)",
                model: "FWindNE",
                id: "FWindNE",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Восток)",
                model: "FWindE",
                id: "FWindE",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Юго-Восток)",
                model: "FWindSE",
                id: "FWindSE",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Юг)",
                model: "FWindS",
                id: "FWindS",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Юго-Запад)",
                model: "FWindSW",
                id: "FWindSW",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Запад)",
                model: "FWindW",
                id: "FWindW",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Средняя скорость ветра (Северо-Запад)",
                model: "FWindNW",
                id: "FWindNW",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость штиля",
                model: "CWind",
                id: "CWind",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Север)",
                model: "PWindN",
                id: "PWindN",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Северо-Восток)",
                model: "PWindNE",
                id: "PWindNE",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Восток)",
                model: "PWindE",
                id: "PWindE",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Юго-Восток)",
                model: "PWindSE",
                id: "PWindSE",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Юг)",
                model: "PWindS",
                id: "PWindS",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Юго-Запад)",
                model: "PWindSW",
                id: "PWindSW",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Запад)",
                model: "PWindW",
                id: "PWindW",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Повторяемость направления ветра (Северо-Запад)",
                model: "PWindNW",
                id: "PWindNW",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Максимальная температура",
                model: "Temperature",
                id: "Temperature",
                required: true,
                validator(value, field, model) {
                  if (isEmpty(value)) return FIELD_IS_REQUIRED;
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  components: {
    Multiselect,
    "vue-form-generator": VueFormGenerator.component,
  },
  watch: {
    selected() {
      if (this.selected && this.selected.ID) {
        this.getCity();
      }
    },
  },
  computed: {},
  methods: {
    loadCities() {
      this.$http.get("risk/cities/list").then((response) => {
        this.cities = response.data;
      });
    },
    getCity() {
      if (this.selected.ID) {
        this.$http.get("risk/cities/get?id=" + this.selected.ID).then((response) => {
          this.city = response.data;
          Object.assign(this.model, this.city);
        });
      }
    },
    save(model) {
      this.model.validator = {};
      this.validate()
        .then((errorsData) => {
          if (errorsData.length) return;
          if (!model.ID) {
            if (this.cities.some(({ CITY }) => CITY === this.model.CITY)) {
              alert("Такой город уже существует, измените название");
              return;
            }
            this.$http
              .post("risk/cities/create", model)
              .then((response) => {
                this.cities.push(response.data);
                this.selected = this.cities[this.cities.length - 1];
                this.$set(this, "validator", {});
                this.$emit("updateCities", this.cities);
              })
              .catch((e) => {
                this.$set(model, "validator", {});
                this.$set(model, "validator", e.response.data);
                this.$refs.form.validate();
              });
          } else {
            if (model.user_id == null) {
              if (model.CITY == this.city.CITY) {
                model.CITY += " (копия)";
              }
              if (
                !confirm(
                  "Стандартный город нельзя изменить, поэтому будет создана копия города с заданными параметрами: " +
                    model.CITY
                )
              ) {
                return false;
              } else {
                model.ID = null;
                this.save(model);
                return false;
              }
            }

            const filteredCitys = this.cities.filter(({ CITY }) => CITY === this.model.CITY);
            if (filteredCitys.length >= 1 && this.city.CITY !== this.model.CITY) {
              if (filteredCitys.some(({ CITY }) => CITY === this.model.CITY)) {
                alert("Такой город уже существует, измените название");
              }
              return;
            }

            this.$http
              .post("risk/cities/update?id=" + model.ID, model)
              .then((response) => {
                var index = this.cities.findIndex((el) => el.ID == model.ID);
                this.$set(this.cities, index, response.data);
                this.selected = this.cities[index];
                this.$emit("updateCities", this.cities);
                this.$set(model, "validator", {});
                this.$refs.form.validate();
              })
              .catch((e) => {
                this.$set(model, "validator", e.response.data);
                this.$refs.form.validate();
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    remove(city) {
      this.$http
        .post("risk/cities/remove?id=" + city.ID)
        .then(() => {
          var index = this.cities.findIndex((el) => el.ID == city.ID);
          this.cities.splice(index, 1);
          this.selected = null;

          this.$emit("updateCities", this.cities);
        })
        .catch((err) => {
          alert(`Ошибка: ${err} `);
        });
    },
    async validate() {
      return await this.$refs.form.validate();
    },
  },
  mounted() {
    this.loadCities();
  },
};
</script>
